import React from 'react'

export default function SMSTemplate() {
  return (
    <div>
      <h1>SMS Template</h1>
    </div>
  )
}
